import AppConstants from '../../config/app.constants';

class BulkCashManagementController {

    /*@ngInject*/
    constructor($state, $q, $window, Modal, $translate, BranchService, OrderViewService ,UserService,UsersService,CommonLayoutService, LocationService, BranchFundingSourceService, DenominationService, BulkCashService, 
                User, CurrencyService, UserBranchService, SetupService, LedgerService, LedgerTransactionService, Sound, DateUtil, $rootScope, UserBranchFundingSourceService, Navigation) {
        this.$q = $q;
        this.$state = $state;
        this.$window = $window;
        this.Sound = Sound;
        // this.audio = this.Sound.errorBeep();
        // this.successAudio = this.Sound.successBeep();
        this.Modal = Modal;
        this.BranchService = BranchService;
        this.LocationService = LocationService;
        this.BranchFundingSourceService = BranchFundingSourceService;
        this.DenominationService = DenominationService;
        this.BulkCashService = BulkCashService;
        this.CurrencyService = CurrencyService
        this.User = User;
        this.UserService = UserService;
        this.UsersService = UsersService;
        this.OrderViewService = OrderViewService;
        this.UserBranchService = UserBranchService
        this.$translate = $translate
        this.SetupService = SetupService;
        this.LedgerService = LedgerService;
        this.CommonLayoutService = CommonLayoutService;
        this.LedgerTransactionService = LedgerTransactionService;
        this.DateUtil = DateUtil;
        this.$rootScope = $rootScope;
        this.userInfo = User.getUser();
        this.UserBranchFundingSourceService = UserBranchFundingSourceService;
        this.Navigation = Navigation;
        this.model = {
            loading: true,
            branchId: null,
            locationId: null,
            orderNumber: null,
            requireAmount: null,
            totalreceivedAmount: 0,
            receivedAmountFlag: false,
            stats: 'Regular',
            date: 7,
            ledger: null,
            isDebit: false,
            loggedInUser: this.User.getUser().id,
            searchText: '',
            vaultDate: '',
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            adjustment: false
        };

        this.ledgers = [
            {
                lable: "Regular",
                value: "regular"
            },
            {
                lable: "Emergency",
                value: "emergency"
            }
        ]

        this.stats = {
            regular: 'Regular',
            emergency: 'Emergency'
        }
        this.dateRanges = [
            {
                lable: 'Last 30 Days',
                value: 30
            },
            {
                lable: 'Last 10 Days',
                value: 10
            },
            {
                lable: 'Last Week',
                value: 7
            }
        ];

        this.orderSort = {
            type: false,
            orderId: false,
            datetime: false,
            order: 'DESC',
            fieldName: 'startTimestamp',
        }

        this.dollorStats = [];
        this.branches = [];
        this.denominationAllType = [];
        this.denominationType = [];
        this.locationLists = [];
        this.denominations = [];
        this.selectedDenomination = [];
        this.fundingSourceDenominations= [];
        this.totalDenominationsAmount = 0;
        this.page = 1
        this.total = 0
        this.pageLimit = 10
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.isClickDenominationFiler = false;
        this.currencyType = [];
        this.currencyData = [];
        this.denominationGrouped = [];
        this.totalBillAmount = 0;
        this.totalAmount = 0;
        this.transactionHistoryObj = {};
        this.currencySymbol = '$';
        this.$rootScope.$broadcast('routeChange', '/app/bulk-cash');
        this.acl = {};
        this.hasACL = {};
        this.permissionKey = 'bulk_cash_management';
        this.hasCreditDebitPermissions = true;
        this.isViewOnly = false;
        this.adjustmentTypes = [
            {
                lable: 'Adjustment In (Credit)',
                value: false,
                isAdjustment: true
            },
            {
                lable: 'Bulk Cash In (Credit)',
                value: false,
                isAdjustment: false
            },
            {
                lable: 'Adjustment Out (Debit)',
                value: true,
                isAdjustment: true
            }
        ];
        this.model.selectedAdjustmentType = this.adjustmentTypes[1];
    }

    setCurrencySymbol() {
        const currencyId = this.model.locationId ? this.model.locationId.currencyId : 
                          (this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : null);
        
        if (currencyId && Array.isArray(this.currencyData) && this.currencyData.length) {
            const currency = this.currencyData.find(c => c.id === currencyId);
            this.currencySymbol = (currency && currency.symbol) ? currency.symbol : '$';
        } else {
            this.currencySymbol = '$';
        }
    }

    setDateRangeOptions(date, dateRangeOption, modelVal) {
        // let currentVaultDate = moment(date).format() || moment();
        this.model[modelVal] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadBulkCashHistory(); 
                    this.getAmountByDenom();
                }
            },
            ranges: {
                'Running 45 Days': [
                    moment().subtract(30, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().add(14, 'days').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Year': [
                    moment().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('year').format('YYYY-MM-DD HH:mm:ss')
                ]
            }
        }
    }

    $onInit() {
        this.moment = moment;
        // if (!this.dollorStats.length) {
        //     this.dollorStats.push('All')
        // }
        this.$q.all([
            this.model.branchId = this.User.getUser().branchId,
            this.SetupService.get(this.model.branchId),
            this.DenominationService.all(null, 0, 1000),
            this.SetupService.all(null, 0, AppConstants.defaultPageSize),
            this.loadPermission(),
            this.UsersService.validateUserPermissions(this.userInfo.firstName, this.userInfo.lastName)
            // this.getLedgerAmountAndDenomBalance()
            // this.bulkCashDenominationHistory()
        ])
            .then((data) => {
                this.hasCreditDebitPermissions = (data[5].hasBulkCashPermission || this.CommonLayoutService.isAllowToAccessPages());
                this.isViewOnly = this.userInfo.customerUser && this.hasACL[this.permissionKey]['view'] && !this.hasACL[this.permissionKey]['all'];
                if (this.isViewOnly) {
                    this.hasCreditDebitPermissions = false;
                }
                this.denominationAllType = data[2].results;
                this.allSetups = data[3].results;
                this.setup = data[1];
                this.allSetups.map((setup) => {
                    if (setup.branchId == this.model.branchId) {
                        this.selectedBranchSetupObj = setup;
                    }
                })
                this._locationPromise = this.getAllLocation('', 0);
                this.defaultBulkCash();
                this.loadCurrency();
                this.focuseElementById('trackingId');
                this.denominationGroup = [];
                this.denominationAllType.map((denomination) => {
                    if (denomination.shiptype.coinFlag == false && this.setup.availableCurrencyIds && this.setup.availableCurrencyIds.includes(denomination.currencyId)) {
                        if(denomination.id == "1"){
                        denomination.icon =  '<img  src="assets/images/$1c.png" />';
                        }
                        if(denomination.id !== "1"){
                            denomination.icon = '<img  src="assets/images/' + denomination.id + '.png" />';
                        }
                        denomination.ticked = false;
                        return this.denominationGroup.push(denomination);
                    }
                })
                const date = this.DateUtil.convertToDate(this.setup.currentVaultDate);
                this.model.vaultDate = moment(date).format('YYYY-MM-DD');
                this.setDateRangeOptions(date, this.model.dateRangeOptions, 'dateRange');
                this.model.dateRangeOptions.startDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
                this.model.dateRangeOptions.endDate = moment().add(14, 'day').format('YYYY-MM-DD');

                this._locationPromise.then(() => {
                    if (this.isViewOnly && this.locationLists.length === 1) {
                        this.model.locationId = this.locationLists[0];
                        this.setCurrencySymbol();
                        this.loadBulkCashHistory();
                        this.fundingSourceDenomination();
                    } else if (!this.isViewOnly && this.locationLists.length === 1) {
                        this.model.locationId = this.locationLists[0];
                        this.setFocus();
                        this.loadBulkCashHistory();
                        this.resetData();
                    }
                });
            });
    }

    loadPermission() {
        this.acl[this.permissionKey] = this.User.getACL(this.permissionKey);
        this.hasACL[this.permissionKey] = {};
        this.acl[this.permissionKey].forEach((permission) => {
            this.hasACL[this.permissionKey][permission] = true;
        });


        if (!this.hasACL[this.permissionKey]['debit']) {
            this.adjustmentTypes = this.adjustmentTypes.filter(type => !type.value);
        }
    }

    focuseElementById(id) {
        if(!this.hasCreditDebitPermissions) return;
        setTimeout(() => {
            const el = document.getElementById(id);
            if (el && typeof el.focus === 'function') {
                el.focus();
            }
        }, 300);
    }

    loadCurrency() {
        const currencyIds = Array.isArray(this.setup.availableCurrencyIds) && this.setup.availableCurrencyIds.length > 0 ? this.setup.availableCurrencyIds : [this.setup.currencyId];

        const currencySearchObj = {
            queryJSON: {
                rules: currencyIds.map(id => ({
                    field: "id",
                    condition: "=", 
                    data: id
                })),
                operator: "OR" // OR because we want currencies matching ANY of the IDs
            }
        }
        return this.CurrencyService.all(currencySearchObj, 0, 100)
            .then((data) => {
                this.currencyData = data.results;
                const currencyId = this.model.locationId ? this.model.locationId.currencyId :
                this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : "USD"
                
                // Initialize filtered currency data
                this.filteredCurrencyData = this.currencyData.filter(currency => currency.id === currencyId);
                
                this.setCurrencySymbol();
                
                // Set currency image path for selectedBranchSetupObj
                if (this.selectedBranchSetupObj && currencyId) {
                    this.selectedBranchSetupObj.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
                }
                
                // Set currency image path for existing bulk cash entries
                if (this.addBulkCash && this.addBulkCash.length > 0) {
                    this.addBulkCash.forEach(bulkCashEntry => {
                        if (bulkCashEntry.currencyId) {
                            bulkCashEntry.currencyIcon = '../../assets/images/' + (bulkCashEntry.currencyId || 'USD') + '.png';
                        }
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            })
        // return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    bulkCashHistorySearchObj() {
        let date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        const searchObj = this.model.branchId ? {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    },
                    {
                        field: 'account',
                        condition: '=',
                        data: this.model.stats
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "startTimestamp",
                                    condition: ">",
                                    data: date
                                },
                                // {
                                //     field: 'branchFundingSourceId',
                                //     condition: '=',
                                //     data: this.model.locationId.Value
                                // },
                            ],
                            operator: "AND"
                        }
                    }
                ],
                operator: 'AND'
            },
            order: {
                fieldName: this.orderSort.fieldName || 'id',
                keyword: this.orderSort.order || 'ASC'
            }
        } : null;

        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getBulkCashHistorys() {
        this.isClickDenominationFiler = false;
        let searchObj = this.bulkCashHistorySearchObj()
        this.LedgerTransactionService
            .all(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit)
            .then((res) => {
                this.pagination.total = res.total;
                this.pagination.loading = false;
                this.bulkCashHistorys = res.results;
                return this.bulkCashHistorys.map((bulkCash) => {
                    bulkCash.mainEntry = bulkCash.ledgers.find((entry) => { return entry.denominationId == null });
                    return bulkCash;
                })
            })
            .then(() => {
                this.getLedgerAmountAndDenomBalance()
                // console.log(this.bulkCashHistorys);
            }).catch((e) => {
                console.log('Error : ', e);
            })
    }

    getLedgerAmountAndDenomBalance() {

        if (!this.model.locationId) {
            return;
        }

        const defer = this.$q.defer(),
            denominations = null;

        const currencyId = this.model.locationId ? this.model.locationId.currencyId : (this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : null);

        this.LedgerTransactionService.getLedgerAmountAndDenomBalance(this.model.branchId, this.model.locationId.Value, denominations, this.model.stats, this.model.vaultDate, currencyId)
            .then((res) => {
                this.curBalance = res.totalAmount;
                this.denomBalance = res.denomBalance;
                if (this.denomBalance && Array.isArray(this.denomBalance)) {
                    this.denomBalance.forEach((data) => {
                        const denom = (this.denominationAllType || []).find(d => d.id === data.denominationId);
                        if (denom) {
                            data.sortOrder = denom.sortOrder;
                            data.faceValue = denom.faceValue;
                        }
                    });
                }
                if (this.addBulkCash && this.addBulkCash.length > 0) {
                    this.addBulkCash.forEach((bulkCash, index) => {
                        this.loadDenomination(bulkCash.currencyId, index);
                    });
                }
                this.setCurrencySymbol();
                defer.resolve();
            }).catch((e) => {
                console.log('Error : ', e);
                defer.reject();
            })
        defer.promise.then(() => {
            this.totalRequireAmount();
        })
    }

    // Modulus Operator

    defaultBulkCash() {
        const currencyId = this.model.locationId ? this.model.locationId.currencyId : (this.currencyData.length > 0 ? this.currencyData[0].id : this.selectedBranchSetupObj.currencyId);
        
        const bulkCashEntry = {
            requireAmount: '',
            ledger: this.ledgers[0].value,
            denominations: [],
            denominationType: [],
            totalreceivedAmount: '',
            checkAndValidate: false,
            currencyId: currencyId,
            currencyIcon: '', 
            currencyIsOpen: '',
            currencyTemplate: 'currencyType-selection.html'
        };
        
        // Set currency image path from currency id
        bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
        
        this.addBulkCash = [bulkCashEntry];
    }

    // load BranchFundingSource data
    loadLocationData(searchKey) {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: "branchId",
                        condition: "=",
                        data: this.model.branchId
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: "id",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                },
                                {
                                    field: "sourceName",
                                    condition: "like",
                                    data: "%" + searchKey + "%"
                                }
                            ],
                            operator: "OR"
                        }
                    }
                ],
                operator: "AND"
            }
        }
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    mappingLocationDatas(locations) {
        return locations.map((location) => {
            return {
                Key: location.id + " | " + location.sourceName,
                Value: location.id,
                currencyId: location.currencyId
            }
        });
    }

    getAllLocation(searchKey, offset) {
        // const loadLocationDatas = this.loadLocationData(searchKey);
        return this.UserBranchFundingSourceService.getBranchFundingSource(this.model.loggedInUser, this.model.branchId)
            .then((data) => {
                if (offset === 0) {
                    this.totalRecords = data.total;
                    this.locationLists = this.mappingLocationDatas(data.results);
                }
                else {
                    const locations = this.mappingLocationDatas(data.results);
                    this.locationLists = this.locationLists.concat(locations);
                }
            })
    }

    setFocus() {
        if (!this.model.locationId) {
            return;
        }
        if (this.hasCreditDebitPermissions) {
            this.focuseElementById('trackingId');
        } else {
            this.focuseElementById(`requireAmount-${this.addBulkCash.length}`);
        }
    }

    addDenomination(bulkCashIndex, denominationIndex) {
        let icon = this.addBulkCash[denominationIndex].filterDenominationType[0].id,
            faceValue = 0;
        this.addBulkCash[bulkCashIndex].denominationType.forEach((denomData) => {
            if (denomData.id == icon) {
                faceValue = denomData.faceValue;
            }
        })
        
        const denomMeta = this.addBulkCash[bulkCashIndex].denominationType.find(d => d.id === icon) || {};
        let coinFlag = denomMeta.coinFlag || (denomMeta.shiptype && denomMeta.shiptype.coinFlag) || 0;
        if (!coinFlag) {
            const fallback = (this.denominationAllType || []).find(d => d.id === icon) || {};
            coinFlag = fallback.coinFlag || (fallback.shiptype && fallback.shiptype.coinFlag) || 0;
        }

        this.addBulkCash[denominationIndex].denominations.push({
            icon: icon,
            faceValue: faceValue,
            amount: null,
            units: null,
            coinFlag: coinFlag,
            template: 'bulk-cash-denomination-selection.html',
            dollorFlag: true,
            duplicate: false
        });

        this.removeAlreadyUsedDenom(denominationIndex)

        this.selectedDenomination[this.addBulkCash[denominationIndex].denominations.length - 1] = this.addBulkCash[bulkCashIndex].denominationType[0].id;
        if (this.addBulkCash[denominationIndex].denominations.length > 1) {
            this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
        }
        this.checkAndValidateCommit(bulkCashIndex);
        if (this.addBulkCash[bulkCashIndex].denominations.length) {
            this.focuseElementById(`denomAmount-${bulkCashIndex + 1}-${this.addBulkCash[bulkCashIndex].denominations.length}`);
        }
        // this.commitDisabled();
    }

    addNewBulkCash() {
        const currencyId = this.model.locationId ? this.model.locationId.currencyId : 'USD';
        
        const bulkCashEntry = {
            requireAmount: '',
            ledger: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
            denominations: [],
            denominationType: [],
            totalreceivedAmount: '',
            // currency: 'USD',
            checkAndValidate: false,
            currencyId: currencyId,
            currencyIcon: '', 
            currencyIsOpen: '',
            currencyTemplate: 'currencyType-selection.html'
        };
        
        // Set currency image path from currency id
        bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
        
        this.addBulkCash.push(bulkCashEntry);
        this.loadDenomination(currencyId, this.addBulkCash.length - 1);
        this.setCurrencySymbol();

        // this.commitDisabled();
    }

    loadAclPermission() {
        this.UserService.acl(this.User.getUser().id, this.model.branch).then((permissions) => {
            this.aclPermission = permissions;
        }).catch(e => console.log('error in permission', e));
    }

    removeDenomination(bulkCashIndex, denominationIndex, bulkCashAmount) {
        this.addBulkCash[bulkCashIndex].denominations.splice(denominationIndex, 1);
        this.calculateAmount(bulkCashIndex, denominationIndex) // check and deduct amount if array removed from stack
        this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
        this.checkAmountWithRequireAmount(bulkCashIndex, denominationIndex, bulkCashAmount);
        // this.commitDisabled();
        this.removeAlreadyUsedDenom(bulkCashIndex);
        if (this.addBulkCash[bulkCashIndex].denominations.length) {
            const elementId = `denomAmount-${bulkCashIndex + 1}-${this.addBulkCash[bulkCashIndex].denominations.length}`;
            const element = document.getElementById(elementId);

            if (element) {
                this.focuseElementById(elementId);
            }
        }
        else {
            this.focuseElementById(`addDenomination-${bulkCashIndex + 1}`)
        }
    }

    removeBulkCash(bulkCashIndex) {
        if (this.addBulkCash.length === 1) {
            return this.Modal.alert({
                type: 'danger',
                header: this.$translate.instant('bulkCash.alertModalTitle'),
                message: this.$translate.instant('bulkCash.alertModalMessage'),
                callback: ({ modal }) => { modal.close(); }
            });
        }

        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_delete_title'),
            message: this.$translate.instant('bulkCash.delete_message'),
            callback: (({
                modal,
                $scope
            }) => {
                this.remove(bulkCashIndex)
                this.totalRequireAmount();
                modal.close()
            }),
            type: 'danger'
        })
    }

    remove(bulkCashIndex) {
        this.addBulkCash[bulkCashIndex] = [];
        this.addBulkCash.splice(bulkCashIndex, 1);
        this.focuseElementById(`requireAmount-${this.addBulkCash.length}`);
    }

    // Calculate Amount for each Value 
    calculateAmount(bulkCashIndex, denominationIndex) {
        this.totalDenominationsAmount = 0;
        this.addBulkCash[bulkCashIndex].denominations.map((denomination) => {
            if (denomination.coinFlag) {
                const computed = Number((denomination.units || 0) * (denomination.faceValue || 0));
                denomination.amount = computed;
            }
            this.totalDenominationsAmount = Number(this.totalDenominationsAmount) + Number(denomination.amount || 0);
        })
        this.addBulkCash[bulkCashIndex].totalreceivedAmount = this.totalDenominationsAmount;
    }

    // change denominationType
    changeType(event, type, bulkCashIndex, denominationIndex, imageIndex, denomFaceValue, amounts) {
        const denomMeta = this.addBulkCash[bulkCashIndex].denominationType.find(d => d.id === type) || {};
        let isCoin = denomMeta.coinFlag || (denomMeta.shiptype && denomMeta.shiptype.coinFlag) || 0;
        if (!isCoin) {
            const fallback = (this.denominationAllType || []).find(d => d.id === type) || {};
            isCoin = fallback.coinFlag || (fallback.shiptype && fallback.shiptype.coinFlag) || 0;
        }
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].icon = type;
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].faceValue = denomFaceValue;
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].coinFlag = isCoin;
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].units = null;
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].amount = null;
        this.selectedDenomination[imageIndex] = this.addBulkCash[bulkCashIndex].denominationType[imageIndex].id;
        this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isOpen = false;

        if (this.addBulkCash[bulkCashIndex].denominations.length > 1) {
            this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
        }
        this.checkAndValidateCommit(bulkCashIndex);
        this.isMultiple(bulkCashIndex, amounts, denomFaceValue, denominationIndex)
        this.removeAlreadyUsedDenom(bulkCashIndex)
    }

    removeAlreadyUsedDenom(index) {
        this.addBulkCash[index].filterDenominationType = this.addBulkCash[index].denominationType.filter(type => {
            let isValid = true;
            this.addBulkCash[index].denominations.forEach((data) => {
                isValid = (!(data.icon === type.id)) && isValid
            })
            return isValid
        })
    }

    //change currencyType
    changeCurrencyType(event, type, bulkCashIndex, currencyIndex) {
        this.addBulkCash[bulkCashIndex].currencyId = type;
        
        // Set currency image path from currency id
        this.addBulkCash[bulkCashIndex].currencyIcon = '../../assets/images/' + (type || 'USD') + '.png';
        
        this.addBulkCash[bulkCashIndex].currencyIsOpen = false;
        this.addBulkCash[bulkCashIndex].denominations = [];
        this.addBulkCash[bulkCashIndex].totalreceivedAmount = 0;
        this.loadDenomination(type, bulkCashIndex);
        this.checkAndValidateCommit(bulkCashIndex);
        this.setCurrencySymbol();
    }

    // load denomination based on currencyType
    loadDenomination(selectedType, bulkCashIndex) {
        this.addBulkCash[bulkCashIndex].denominations = [];
        this.addBulkCash[bulkCashIndex].denominationType = [];
        this.addBulkCash[bulkCashIndex].filterDenominationType = [];
        const sourceDenoms = this.model.isDebit ? this.denominationAllType : this.fundingSourceDenominations;
        
        sourceDenoms.forEach((denominationType) => {
            const isMatchingDenom = (this.denomBalance || []).some(
                (denom) => denom.denominationId === denominationType.id && denom.balance !== 0
            );
            if (denominationType.currencyId == selectedType && (isMatchingDenom || !this.model.isDebit)) {
                this.addBulkCash[bulkCashIndex].denominationType.push(denominationType);
                this.addBulkCash[bulkCashIndex].filterDenominationType.push(denominationType);
            }
        });
    }

    checkAmountWithRequireAmount() {
        this.addBulkCash.forEach((bulkCash, bulkCashIndex) => {
            const requiredNum = Number(bulkCash.requireAmount || 0);
            bulkCash.denominations.forEach((denomination, denominationIndex) => {
                this.calculateAmount(bulkCashIndex, denominationIndex);
                if (bulkCash.denominations.length > 1) {
                    this.checkDuplicateEntry(bulkCashIndex, denominationIndex);
                }
                this.checkAndValidateCommit(bulkCashIndex);

                const isCoin = !!denomination.coinFlag;
                const effectiveAmount = isCoin ? 
                    Number(denomination.units || 0) * Number(denomination.faceValue || 0) : 
                    Number(denomination.amount || 0);


                this.isMultiple(bulkCashIndex, effectiveAmount, Number(denomination.faceValue || 0), denominationIndex, requiredNum)
            });
        })
    }

    totalRequireAmount() {
        this.totalAmount = 0;
        if (this.addBulkCash && this.addBulkCash.length) {
            this.addBulkCash.forEach((bulkCash) => {
                this.totalAmount += bulkCash.requireAmount ? bulkCash.requireAmount : 0;
                if (this.model.isDebit) {
                    bulkCash.ledger = this.model.stats === 'Regular' ? 'regular' : 'emergency';
                }
            })
        }
        if (this.model.isDebit) {
            this.isLimitExceed = this.totalAmount > this.curBalance;
            if (this.isLimitExceed) this.limitExceededErr = this.$translate.instant('bulkCash.error_limitExceeded')
            else delete this.limitExceededErr;
        }
        else {
            this.isLimitExceed = false;
            delete this.limitExceededErr
        }
    }

    isMultiple(bulkCashIndex, amounts, denomFaceValue, denominationIndex, bulkCashAmount) {
        const currentDenom = this.addBulkCash[bulkCashIndex].denominations[denominationIndex];
        const denomBalance = this.denomBalance.find(balance => balance.denominationId === currentDenom.icon);

        const amt = Number(amounts || 0);
        const fv = Number(denomFaceValue || 0);
        const required = Number(bulkCashAmount || 0);
        const isCoin = !!currentDenom.coinFlag;


        if (isCoin) {
            const unitsNum = Number(currentDenom.units || 0);
            const computed = unitsNum * fv;
            const exceedsBalance = this.model.isDebit && denomBalance && computed > Number(denomBalance.balance || 0);
            if (!(unitsNum > 0) || (required > 0 && computed > required) || exceedsBalance) {
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
            } else {
                this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = true;
            }
            return;
        }

        if ((fv > 0 && amt % fv > 0) || (required > 0 && amt > required)) {
            this.addBulkCash[bulkCashIndex].checkAndValidate = false;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
        }
        else if (denomBalance && amt > denomBalance.balance && this.model.isDebit) {
            this.addBulkCash[bulkCashIndex].checkAndValidate = false;
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
        }
        else if (fv > 0 && amt > 0 && amt % fv === 0) {
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = true;
        }
        else {
            this.addBulkCash[bulkCashIndex].denominations[denominationIndex].isValidate = false;
        }
    }

    // Check Duplicate Entries
    checkDuplicateEntry(bulkCashIndex, denominationIndex) {
        this.addBulkCash[bulkCashIndex].denominations = _.map(this.addBulkCash[bulkCashIndex].denominations, (mainObj, mainObjIndex) => {
            mainObj.duplicate = false;
            this.isValidDirective = true;
            let eq = _.find(this.addBulkCash[bulkCashIndex].denominations, (compairObject, compairObjIndex) => {
                if (mainObjIndex > compairObjIndex) {
                    return compairObject.icon == mainObj.icon
                }
            });
            if (eq) {
                mainObj.duplicate = true;
                this.isValidDirective = false;
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
                return mainObj;
            } else {
                return mainObj;
            }
        });
    }

    loadLedgerData(bulkCashIndex, denominationIndex, account) {
        this.checkAndValidateCommit(bulkCashIndex);
        // this.checkAmountWithRequireAmount();
    }

    fundingSourceDenomination() {
        if(!this.model.locationId) {
            return;
        }
        const currencyId = this.model.locationId.currencyId;
        const bfsId = this.model.locationId.Value;
        
        if (!currencyId) {
            console.error('No currency ID found for selected BFS');
            return;
        }

        // Fetch BFS-selected denominations and filter by currency
        this.BranchFundingSourceService.get(bfsId)
            .then((data) => {
                const denomMap = (data && data.results && data.results.denominations) ? data.results.denominations : {};
                const billsForCurrency = Array.isArray(denomMap[currencyId]) ? denomMap[currencyId] : [];
                const coinsForCurrency = Array.isArray(denomMap['Coin']) ? denomMap['Coin'].filter(d => d.currencyId === currencyId) : [];
                this.fundingSourceDenominations = billsForCurrency.concat(coinsForCurrency);

                // Update denominationGroup for the dropdown (exclude coins)
                // this.denominationGroup = [];
                // this.fundingSourceDenominations.forEach((denomination) => {
                //     if(denomination.id == "1"){
                //         denomination.icon = '<img  src="assets/images/$1c.png" />';
                //     }
                //     if(denomination.id !== "1"){
                //         denomination.icon = '<img  src="assets/images/' + denomination.id + '.png" />';
                //     }
                //     denomination.ticked = false;
                //     this.denominationGroup.push(denomination);
                // });

                // Update the currency ID and image path to match the BFS currency
                if (this.addBulkCash && this.addBulkCash.length > 0) {
                    this.addBulkCash[0].currencyId = currencyId;
                    this.addBulkCash[0].currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
                }

                // Filter currencyData for popover to only show the selected BFS currency
                this.filteredCurrencyData = this.currencyData.filter(currency => currency.id === currencyId);

                this.setCurrencySymbol();

                // Load denominations for the updated currency using BFS-selected list
                this.loadDenomination(currencyId, 0);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    denominationSearchObj() {
        let selectedDollorStats = this.dollorStats.map((dollorStat) => dollorStat.id)
        const searchObj = this.model.branchId ? {
            queryJSON: {
                rules: [
                    {
                        field: 'branchId',
                        condition: '=',
                        data: this.model.branchId
                    },
                    {
                        field: 'account',
                        condition: '=',
                        data: this.model.stats
                    },
                    // {
                    //     field: 'denominationId',
                    //     condition: 'IN',
                    //     data: selectedDollorStats
                    // },
                    // {
                    //     group: {
                    //         rules: [
                    //             {
                    //                 field: "timestamp",
                    //                 condition: ">",
                    //                 data: date
                    //             },
                    //         ],
                    //         operator: "AND"
                    //     }
                    // }
                ],
                operator: 'AND'
            },
            order: {
                fieldName: this.orderSort.fieldName || 'id',
                keyword: this.orderSort.order || 'ASC'
            }
        } : null;

        if (selectedDollorStats.length) {
            searchObj.queryJSON.rules.push({
                field: 'denominationId',
                condition: 'IN',
                data: selectedDollorStats
            })
        }

        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    bulkCashDenominationHistory() {

        if (!this.model.locationId) {
            return this.resetBulkCashDenomination();
        }

        this.isClickDenominationFiler = true;
        // let date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
        const searchObj = this.denominationSearchObj();
        this.LedgerTransactionService.getLedgerDenomination(searchObj, (this.pagination.page - 1) * this.pagination.pageLimit, this.pagination.pageLimit, this.model.searchText, startDate, endDate,  this.model.locationId.Value)
            .then((res) => {
                this.bulkCashHistorys = res.results;
                this.bulkCashHistorys.map((bulkCash, index) => {
                    var startBalance = 0;
                    let nextIndex = index + 1;
                    let nextRecord = this.bulkCashHistorys[nextIndex] ? this.bulkCashHistorys[nextIndex] : null;

                    bulkCash.ledgers.forEach((ledger) => {
                        if (ledger.denomination) { startBalance += ledger.change * ledger.denomination.faceValue; }
                        bulkCash.mainEntry = bulkCash.ledgers.find((entry) => { return entry.denominationId == null });
                        bulkCash.nextEntry = nextRecord ? nextRecord.ledgers.find((entry) => { return entry.denominationId == null }) : null;
                    })
                    let depositRecords = bulkCash.depositRecords || bulkCash.depositrecords || [];
                    let fromLoc = null;
                    let toLoc = null;

                    if (depositRecords.length > 0) {
                        fromLoc = depositRecords[0].fromLocation || depositRecords[0].fromlocation;
                        toLoc = (depositRecords[0].shipment && depositRecords[0].shipment.toLocation) ? depositRecords[0].shipment.toLocation : (bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null);
                    } else if (bulkCash.shipmentLocation) {
                        fromLoc = bulkCash.shipmentLocation.fromLocation;
                        toLoc = bulkCash.shipmentLocation.toLocation ? bulkCash.shipmentLocation.toLocation : (bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null);
                    } else if (bulkCash.branchFundingSource && bulkCash.branchFundingSource.location) {
                        fromLoc = bulkCash.branchFundingSource.location;
                    }
                    if (bulkCash.adjustment) {
                        fromLoc = null;
                        toLoc = null;
                    }
                    bulkCash.fromLocationName = fromLoc ? (fromLoc.id + ' | ' + fromLoc.name) : 'N/A';
                    bulkCash.toLocationName = toLoc ? (toLoc.id + ' | ' + toLoc.name) : 'N/A';
                    bulkCash.fromLocation = fromLoc;
                    bulkCash.toLocation = toLoc;
                    bulkCash.type = startBalance;
                    bulkCash.startBalance = startBalance;
                    bulkCash.endBalance = startBalance;
                    bulkCash.isBalanceMismatched = bulkCash.totalValue !==0 && bulkCash.nextEntry && bulkCash.mainEntry && bulkCash.mainEntry.prevBalance !== bulkCash.nextEntry.curBalance ? true : false;
                    return bulkCash;
                })
                this.pagination.total = res.total;
                this.pagination.loading = false;
            })
            .then(() => {
                this.getLedgerAmountAndDenomBalance()
            })
            .catch((err) => {
                this.pagination.loading = false;
                this.Modal.errorModal(err.data.message || err.data || err.message);
            })
    }

    resetBulkCashDenomination() {
        this.bulkCashHistorys = [];
        this.model.date = 7;
        this.curBalance = 0;
        this.resetDenomSelection();
    }

    goToServiceHistory(locationId) {
        return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }

    loadBulkCashHistory(rating) {
        // var index = this.dollorStats.indexOf(rating);

        // if (index > -1) {
        //     this.dollorStats.splice(index, 1);
        // }
        // else {
        //     this.dollorStats.push(rating);
        // }
        this.pagination.page = 1;
        this.bulkCashDenominationHistory();
        // console.log(this.dollorStats)
    };

    resetLedgerData() {
        this.resetDenomSelection();
        this.bulkCashDenominationHistory();
    }
    checkAndValidateCommit(bulkCashIndex) {
        // if (this.addBulkCash[bulkCashIndex].denominations.length > 0) {
        if (Number(this.addBulkCash[bulkCashIndex].totalreceivedAmount).toFixed(2) == Number(this.addBulkCash[bulkCashIndex].requireAmount).toFixed(2)) {
            let isDuplicate = this.addBulkCash[bulkCashIndex].denominations.map((data) => {
                if (data.duplicate) {
                    return data.duplicate;
                }
                else if ((data.coinFlag && !this.model.isDebit && (data.units == undefined || data.units == null)) || (!data.coinFlag && (data.amount == undefined || data.amount == null))) {
                    return true;
                }
                else {
                    return false
                }
            })
            if (isDuplicate.indexOf(true) >= 0) {
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
            } else {
                this.addBulkCash[bulkCashIndex].checkAndValidate = true;
            }
            if (!this.addBulkCash[bulkCashIndex].ledger)
                this.addBulkCash[bulkCashIndex].checkAndValidate = false;
        }
        else {
            this.addBulkCash[bulkCashIndex].checkAndValidate = false;
        }
    }

    // check and validate commit button 
    commitDisabled() {
        var disableButton = this.addBulkCash.map((data) => {
            this.validate = true;
            data.denominations.map((denom) => {
                this.validate = this.validate && denom.isValidate;
            })
            return data.checkAndValidate && this.validate
        })
        if (disableButton.indexOf(false) >= 0) return true;
        else return false;
    }

    pageChange() {
        this.bulkCashDenominationHistory();
    }

    accountChange() {
        this.pagination = {
            page: 1,
            total: 0,
            pageLimit: 10,
            maxPages: 10
        };
        this.orderSort.fieldName = 'startTimestamp';
        this.orderSort.order = 'DESC';
        this.denomBalance = [];
        this.bulkCashDenominationHistory();
        this.getAmountByDenom();
        this.updateLedgerAccount();
    }

    resetData() {
        const currencyId = this.model.locationId ? this.model.locationId.currencyId : 
                          (this.selectedBranchSetupObj ? this.selectedBranchSetupObj.currencyId : "USD");
        
        const bulkCashEntry = {
            requireAmount: '',
            ledger: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
            denominations: [],
            totalreceivedAmount: '',
            checkAndValidate: false,
            currencyId: currencyId,
            currencyIcon: '', 
            denominationType: '',
            currencyIsOpen: '',
            currencyTemplate: 'currencyType-selection.html'
        };
        
        // Set currency image path from currency id
        bulkCashEntry.currencyIcon = '../../assets/images/' + (currencyId || 'USD') + '.png';
        
        this.addBulkCash = [bulkCashEntry];
        this.model.orderNumber = "";
        // this.model.locationId = "";
        this.loadDenomination(currencyId, 0);
        this.setCurrencySymbol();
        
        if (this.model.locationId) {
            this.fundingSourceDenomination();
        }
        
        this.isCommited = false;
        this.model.selectedAdjustmentType = this.adjustmentTypes[1];
        this.model.isDebit = false;
        this.model.adjustment = false;
        this.model.comments = null;
        // this.updateAdjustmentValue();
        delete this.limitExceededErr;
    }

    // reset all data
    performReset() {
        this.isPerformReset = true;
        this.Modal.confirm({
            header: this.$translate.instant('common.reset'),
            message: this.$translate.instant('bulkCash.resetData'),
            callback: ({
                modal
            }) => {
                this.resetData();
                modal.close();
                this.isPerformReset = false;
                this.model.selectedAdjustmentType = this.adjustmentTypes[1];
                this.model.isDebit = false;
                this.model.adjustment = false;
                this.model.comments = null;
                // this.updateAdjustmentValue();
                // this.curBalance = 0;
            },
            negative: (({
                modal,
            }) => {
                this.isPerformReset = false;
                modal.close();
            }),
            type: 'danger'
        })
    }

    commit() {
        this.isCommited = true;
        let totalAmount = 0;
        let currentDate = moment();
        let bulkCashComment = this.model.orderNumber;
        let endBalance = this.curBalance;

        this.addBulkCash.forEach((data) => {
            if (this.model.isDebit) {
                data.denominations.forEach((denom) => {
                    denom.amount = -Math.abs(denom.amount);
                    denom.isDebit = true;
                    denom.userId = this.model.loggedInUser;
                    denom.startBalance = this.curBalance;
                    endBalance = endBalance + denom.amount;
                    denom.endBalance = endBalance;
                })
            }
            totalAmount += data.totalreceivedAmount || 0;
        })

        // if (this.model.isDebit) {
        //     this.Modal.bulkCashAdjustComment(this.addBulkCash, ({ modal, comments }) => {
        //         bulkCashComment = bulkCashComment ? bulkCashComment.concat(' ', comments) : comments;
        //         return this.commitBulkCash(totalDollerAmount, totalEuroAmount, currentDate, bulkCashComment, modal);
        //     }, ({ modal }) => {
        //         this.isCommited = false;
        //         if (modal) modal.close();
        //     });
        // }
        // else {
            bulkCashComment = (bulkCashComment && this.model.comments) ? bulkCashComment.concat(' | ', this.model.comments) : bulkCashComment ? bulkCashComment : this.model.comments;
            return this.commitBulkCash(totalAmount, currentDate, bulkCashComment, null);
        // }
    }

    commitBulkCash(totalAmount, currentDate, comment, bulkCashAdjustCommentModal) {
        // Add Bulk Cash
        this.BulkCashService.commitBulkCash(this.model.branchId, this.model.locationId.Value, this.addBulkCash, comment, true, 'bulkCash', this.model.isDebit, this.model.adjustment)
            .then(() => {
                let ledgerAdjustMessage = this.$translate.instant('bulkCash.adjustLedger');
                let successMessage = this.$translate.instant('bulkCash.successMessage');
                let msg = this.model.isDebit ? ledgerAdjustMessage : successMessage;
                let transactionType = this.model.isDebit ? 'Debit' : 'Credit';

                this.Modal.commitSuccessModal(totalAmount, null, currentDate, msg, transactionType, ({ modal }) => {
                    modal.close();
                    this.Sound.playSuccessBeep("#success_beep");
                    this.resetData();

                    this.focuseElementById('trackingId');

                    // this.getLedgerAmountAndDenomBalance();
                    
                    if (this.model.locationId) {
                        setTimeout(() => {
                            this.loadBulkCashHistory();
                        }, 100);
                    }
                }, this.currencySymbol);
            })
            .catch((err) => {
                console.log(err);
                this.Sound.PlayErrorBeep("#scanner_beep");
                if (err && err.data && err.data.message === 'ER_SIGNAL_EXCEPTION: E_LEDGERTRANSACTION_ACTIVE') {
                    return this.Modal.errorModal('error.95001')
                }
                else {
                    this.Modal.errorModal('error.' + err.data.message);
                }
            })
            .finally(() => {
                this.isCommited = false;
                if (bulkCashAdjustCommentModal) bulkCashAdjustCommentModal.close();
            })
    }

    // reset denom selection
    resetDenomSelection() {
        this.denominations = [];
        this.dollorStats = [];
        this.denominationAllType.map((denomination) => {
            denomination.ticked = false;
        })
        // Reset currencyData to show all currencies when no BFS is selected
        if (this.originalCurrencyData) {
            this.currencyData = [...this.originalCurrencyData];
        }
    }

    sortRecord(fieldName) {
        this.orderSort.order = 'DESC';
        if (fieldName == 'startTimestamp') {
            this.orderSort.datTime = !this.orderSort.datTime;
            if (this.orderSort.datTime) {
                this.orderSort.order = 'ASC'
            }
            this.orderSort.fieldName = fieldName;
        }
        this.bulkCashDenominationHistory();
    }

    getAmountByDenom() {
        if (!this.model.locationId) return;
        // let date = this.moment.utc().subtract(this.model.date, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss');
        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
        let selectedDollorStats = this.dollorStats.map((dollorStat) => dollorStat.id);
        this.LedgerTransactionService.getLedgerDenomTotal(this.model.branchId, this.model.stats, selectedDollorStats.toString(), this.model.locationId.Value)
            .then((data) => {
                if (data && data.results.length) {
                    this.denominations = data.results;
                    this.denominations.forEach((data) => {
                        const denom = (this.denominationAllType || []).find(d => d.id === data.denominationId);
                        if (denom) {
                            data.sortOrder = denom.sortOrder;
                            data.faceValue = denom.faceValue;
                        }
                    });
                }
                else this.denominations = [];
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal('error.' + err.data.message);
                }
            })
        // if (data.length) {
        //     this.totalDenomAmount = 0;
        //     this.denominations = {};

        //     data.forEach((d) => {
        //         const grouped = _.groupBy(d.ledgers, 'denominationId');
        //         const keys = Object.keys(grouped);

        //         keys.map((denomId) => {
        //             if (denomId !== "null") {
        //                 this.denominations[denomId] = {
        //                     denomAmount: 0
        //                 };
        //             }
        //         })
        //     })

        //     data.forEach((d) => {
        //         const grouped = _.groupBy(d.ledgers, 'denominationId');
        //         const keys = Object.keys(grouped);

        //         keys.map((denomId) => {
        //             if (denomId !== "null") {
        //                 grouped[denomId].map(data => {
        //                     if (data.denominationId && data.denomination) {
        //                         this.denominations[denomId].icon = `assets/images/${denomId}.png`;
        //                         this.denominations[denomId].denomAmount += (data.change * data.denomination.faceValue);
        //                     }
        //                 })
        //             }
        //         })
        //     })
        // }
    }

    showLog(data) {
        this.Modal.ledgerTransactionLogModal(data, ({ modal }) => {
            modal.close();
        }, ({ modal }) => {
            modal.close();
        })
    }

    updateLedgerAccount() {
        this.addBulkCash.forEach((data) => {
            if (this.model.stats === this.stats.regular) data.ledger = 'regular';
            else if (this.model.stats === this.stats.emergency) data.ledger = 'emergency';
        })
    }

    // updateAdjustmentValue() {
    //     this.model.isDebit ? this.model.adjustment = true : this.model.adjustment = false;
    // }
    
    isManualAdjustment(bulkCashDetails) {
        if (!bulkCashDetails.mainEntry) return;

        if (!bulkCashDetails.comment || bulkCashDetails.mainEntry.change >= 0) return;

        const adjustmentList = ['Undo pack of:', 'Order pack tracking:', 'Creating emergency deposit for', 'Creating deposit for', 'Editing residual:', 'Coin Shipment Checkout'];
        const len = adjustmentList.length;

        for (let i = 0; i < len; i++) {
            const regex = new RegExp(adjustmentList[i], 'i');
            if (bulkCashDetails.comment.match(regex)) return false;
        }
        return true;
    }

    updateBulkCashFlag(bulkCashDetails) {
        // console.log('bulkCashDetails', bulkCashDetails.id, bulkCashDetails.bulkCash);
        this.transactionHistoryObj[bulkCashDetails.id] = { process: true };
        this.BulkCashService.updateBulkCashFlag(bulkCashDetails.id, bulkCashDetails.bulkCash)
            .then(() => { })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.transactionHistoryObj[bulkCashDetails.id].process = false;
            })
    }

    findAdjustmentType(type) {
        this.model.adjustment = type.isAdjustment;
        this.model.isDebit = type.value;
        if (this.addBulkCash && this.addBulkCash.length > 0) {
            this.addBulkCash.forEach((bulkCash, index) => {
                this.loadDenomination(bulkCash.currencyId, index);
            });
        }
    }

    printBulkCash() {
        let path = this.$state.href('printBulkCash');
        window.w = window.open(path, '_blank');

        let branchName = this.model.branchId;
        if (this.selectedBranchSetupObj && this.selectedBranchSetupObj.branchName) {
            branchName = this.model.branchId + " | " + this.selectedBranchSetupObj.branchName;
        }

        let locationName = "";
        if (this.model.locationId && this.model.locationId.Key) {
            locationName = this.model.locationId.Key;
        }

        let dateRange = "";
        if (this.model.dateRangeOptions && this.model.dateRangeOptions.startDate) {
            dateRange = "(" + moment(this.model.dateRangeOptions.startDate).format('Do MMMM, YYYY') + ") To (" + moment(this.model.dateRangeOptions.endDate).format('Do MMMM, YYYY') + ")";
        }

        window.w.printData = null;

        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
        const searchObj = this.denominationSearchObj();

        this.LedgerTransactionService.getLedgerDenomination(searchObj, 0, this.pagination.total || 1000, this.model.searchText, startDate, endDate, this.model.locationId.Value)
            .then((res) => {
                let allHistorys = res.results.map((bulkCash, index) => {
                    var startBalance = 0;
                    let nextIndex = index + 1;
                    let nextRecord = res.results[nextIndex] ? res.results[nextIndex] : null;

                    bulkCash.ledgers.forEach((ledger) => {
                        if (ledger.denomination) { startBalance += ledger.change * ledger.denomination.faceValue; }
                        bulkCash.mainEntry = bulkCash.ledgers.find((entry) => { return entry.denominationId == null });
                        bulkCash.nextEntry = nextRecord ? nextRecord.ledgers.find((entry) => { return entry.denominationId == null }) : null;
                    })
                    let depositRecords = bulkCash.depositRecords || bulkCash.depositrecords || [];
                    let fromLoc = null;
                    let toLoc = null;

                    if (depositRecords.length > 0) {
                        fromLoc = depositRecords[0].fromLocation || depositRecords[0].fromlocation;
                        toLoc = (depositRecords[0].shipment && depositRecords[0].shipment.toLocation) ? depositRecords[0].shipment.toLocation : (bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null);
                    } else if (bulkCash.shipmentLocation) {
                        fromLoc = bulkCash.shipmentLocation.fromLocation;
                        toLoc = bulkCash.shipmentLocation.toLocation ? bulkCash.shipmentLocation.toLocation : (bulkCash.branchFundingSource ? bulkCash.branchFundingSource.location : null);
                    } else if (bulkCash.branchFundingSource && bulkCash.branchFundingSource.location) {
                        fromLoc = bulkCash.branchFundingSource.location;
                    }
                    if (bulkCash.adjustment) {
                        fromLoc = null;
                        toLoc = null;
                    }
                    bulkCash.fromLocationName = fromLoc ? (fromLoc.id + ' | ' + fromLoc.name) : 'N/A';
                    bulkCash.toLocationName = toLoc ? (toLoc.id + ' | ' + toLoc.name) : 'N/A';
                    bulkCash.fromLocation = fromLoc;
                    bulkCash.toLocation = toLoc;
                    bulkCash.type = startBalance;
                    bulkCash.startBalance = startBalance;
                    bulkCash.endBalance = startBalance;
                    bulkCash.isBalanceMismatched = bulkCash.totalValue !== 0 && bulkCash.nextEntry && bulkCash.mainEntry && bulkCash.mainEntry.prevBalance !== bulkCash.nextEntry.curBalance ? true : false;
                    return bulkCash;
                });

                if (window.w) {
                    window.w.printData = {
                        denomBalance: this.denomBalance,
                        bulkCashHistorys: allHistorys,
                        currencySymbol: this.currencySymbol,
                        branchName: branchName,
                        locationName: locationName,
                        dateRange: dateRange,
                        searchText: this.model.searchText,
                        curBalance: this.curBalance,
                        accountType: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
                        ready: true
                    };
                }
            }).catch((err) => {
                console.log("Error fetching bulk cash history for print", err);
            });
    }

    exportToExcel() {
        var startDate = moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD HH:mm:ss');
        var endDate = moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD 23:59:59');
        const searchObj = this.denominationSearchObj();

        let payload = {
            search: JSON.stringify(searchObj),
            orderNo: this.model.searchText,
            startDate: startDate,
            endDate: endDate,
            fundingSourceId: this.model.locationId.Value,
            branchId: this.model.branchId,
            account: this.model.stats === this.stats.regular ? 'regular' : 'emergency',
            timezone: moment.tz.guess()
        };

        this.isExporting = true;
        let fundingSourceName = this.model.locationId && this.model.locationId.Key ? this.model.locationId.Key : '';
        this.LedgerTransactionService.exportBulkCashHistoryExcel(payload, fundingSourceName)
            .then(() => {
            }).catch((err) => {
                console.log("Error exporting bulk cash history excel", err);
            }).finally(() => {
                this.isExporting = false;
            });
    }
}

export default BulkCashManagementController;



// WEBPACK FOOTER //
// ./client/app/components/bulk_cash_management/bulk_cash_management.controller.js